{
  "moreActions": "פעולות נוספות",
  "unavailable": "לא זמין, הרחב לפרטים"
}
